import { supabase } from '../lib/supabase';

const SUPABASE_URL = import.meta.env?.VITE_SUPABASE_URL;

async function callSchedulePost(body) {
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token || '';
  const anonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

  const res = await fetch(`${SUPABASE_URL}/functions/v1/schedule-post`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      'apikey': anonKey,
    },
    body: JSON.stringify({ ...body, userId: session?.user?.id }),
  });

  const data = await res.json();

  if (!res.ok || data.error === 'limit_reached') {
    const err = new Error(data?.message || data?.error || 'Request failed');
    err.code = data?.error;
    err.used = data?.used;
    err.limit = data?.limit;
    err.daysUntilReset = data?.daysUntilReset;
    throw err;
  }

  return data;
}

export async function createScheduledPost({
  linkedinContent,
  twitterContent,
  platforms,
  scheduledAt,
  timezone,
  contentPostId,
  imageData,
}) {
  return callSchedulePost({
    action: 'create',
    linkedinContent,
    twitterContent,
    platforms,
    scheduledAt,
    timezone,
    contentPostId,
    imageData,
  });
}

export async function updateScheduledPost(scheduledPostId, updates) {
  return callSchedulePost({
    action: 'update',
    scheduledPostId,
    ...updates,
  });
}

export async function cancelScheduledPost(scheduledPostId) {
  return callSchedulePost({
    action: 'cancel',
    scheduledPostId,
  });
}

export async function listScheduledPosts(status) {
  return callSchedulePost({
    action: 'list',
    status,
  });
}
